import { render, staticRenderFns } from "./DisconnectedSession.vue?vue&type=template&id=2ddc7188&scoped=true&"
import script from "./DisconnectedSession.vue?vue&type=script&lang=js&"
export * from "./DisconnectedSession.vue?vue&type=script&lang=js&"
import style0 from "./DisconnectedSession.vue?vue&type=style&index=0&id=2ddc7188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc7188",
  null
  
)

export default component.exports